export default "assets/images/icons/ampoule-021ca270.svg";